// extracted by mini-css-extract-plugin
export var actions = "_17-0";
export var actionsContainer = "_17-7";
export var border = "_17-1";
export var childFullHeight = "_17-f";
export var collapse = "_17-2";
export var content = "_17-a";
export var contentChild = "_17-e";
export var fullscreen = "_17-c";
export var hasLeftRadius = "_17-k";
export var headerContainer = "_17-3";
export var headerRow = "_17-5";
export var hidePadding = "_17-b";
export var navCollapsedGap = "_17-l";
export var noScrollX = "_17-m";
export var noScrollY = "_17-n";
export var noTopPadding = "_17-i";
export var optOutTopPadding = "_17-d";
export var pageMain = "_17-j";
export var pageOuter = "_17-g";
export var pagePadding = "_17-8";
export var pageScroll = "_17-9";
export var profile = "_17-o";
export var profileContainer = "_17-p";
export var profileImage = "_17-q";
export var profileMain = "_17-r";
export var profileSubtitle = "_17-t";
export var profileTitle = "_17-s";
export var showLeftPadding = "_17-h";
export var tabsPortalSlot = "_17-6";
export var tabsWrapper = "_17-4";
export var title = "_17-u";